// extracted by mini-css-extract-plugin
export default {"SidebarNav":"JXBkEMfe"};